import _ from "lodash";
let data = {
  all:null,
  filtered: null,
  sortBy: 'price_up' // 'price_up', 'price_down'
}

const set = (activityPackages) => {
  data.all = activityPackages;
  data.filtered = activityPackages;
}

const get = () => {
  return data.all || [];
}

const getFiltered = () => {
  return data.filtered || [];
}

const getBySlug = (slug) => {
  const activityPackage = data.all.find(ap => ap.slug === slug);

  return activityPackage || null;
}

const getMinMaxPriceConfiguration = (activityPackage) => {
  const allPriceConfigurations = [];
  activityPackage.regionVariants.forEach(rv => {
    rv.priceConfigurations.forEach(pc => {
      if(pc.price !== 0 && pc.participantCount !== 0) {
        allPriceConfigurations.push(pc);
      }
    })
  })
  const min = _.minBy(allPriceConfigurations, pc => pc.price);
  const max = _.maxBy(allPriceConfigurations, pc => pc.price);
  return {min, max};
}


const filter = ({regions, genders, categories, text, priceRange, kinds, tags}) => {
  if(_.isNil(data.all)) {
    return null
  }

  let filtered = data.all
    .filter(ap => {
      // price range
      const minMax = getMinMaxPriceConfiguration(ap);
      let min = priceRange.min;
      let max = priceRange.max < 200 ? priceRange.max : 9999999;
      return minMax.min.price >= min && minMax.min.price <= max;
    })
    .filter(ap => {
      // region
      if (regions.items.length > 0 && regions.allSelected === false) {
        const apRegions = ap.regionVariants.map(rv => rv.regionCode);
        
        const intersection = _.intersection(apRegions, regions.items);
        return intersection.length > 0;
      }
      return true;
    })

  // sort it
  const sorted = _sort(filtered);

  // we replace the data to ensure react fires state changes
  data = {
    all:data.all,
    filtered:sorted,
    sortBy:data.sortBy
  }
  // and return it
  return data
}

const sort = (sortBy) => {
  data.sortBy = sortBy;
  const sorted = _sort(data.filtered);
  // we replace the data to ensure react fires state changes
  data = {
    all:data.all,
    filtered:sorted,
    sortBy:sortBy
  }

  // return data
  return data;
}

const _sort = (filtered) => {
  return filtered
    .map(a => a) // to make sure we have a new array
    .sort((a, b) => {
      let result = 0
      switch(data.sortBy) {
        case "sales_rank":
          result = 0; // we have no sales rank for packages
          break
        case "price_up":
          result = _sortPrice(a, b, 'asc');
          break
        case "price_down":
        default:
          result = _sortPrice(a, b, 'desc');
          break
      }
      return result
    })
}

const _sortPrice = (a, b, direction) => {
  const minMax_a = getMinMaxPriceConfiguration(a);
  const minMax_b = getMinMaxPriceConfiguration(b);
  if (minMax_a.min.price === minMax_b.min.price) {
    return _sortName(a, b);
  }
  else {
    return direction === 'asc' ?
    minMax_a.min.price - minMax_b.min.price :
    minMax_b.min.price - minMax_a.min.price
  }
}

const _sortName = (a, b, direction) => {
  let r = 0
  if (a.title.toLowerCase() > b.title.toLowerCase()) {
    r = 1
  }
  else if (a.title.toLowerCase() < b.title.toLowerCase()) {
    r = -1
  }
  r = direction === 'asc' ? r : -1 * r
  return r
}

export default {set, get, filter, sort, getFiltered, getBySlug, getMinMaxPriceConfiguration}